export default [
	{
		path: "/withdraws",
		name: "Withdraws",
		meta: {
			requiresAuth: true,
			section: "withdraw"
		},
		component: () => import("@/views/withdraw/Withdraws")
	},
	{
		path: "/withdraws/request",
		name: "WithdrawRequest",
		meta: {
			requiresAuth: true,
			section: "withdraw"
		},
		component: () => import("@/views/withdraw/Withdraw")
	}
]
